import { createServerSideHelpers } from "@trpc/react-query/server";
import superjson from "superjson";

import { appRouter } from "~/server/trpc/root";
import { createTRPCContext } from "~/server/trpc/trpc";

export async function getStaticProps() {
  // create ssg helpers
  const ssg = createServerSideHelpers({
    router: appRouter,
    // skip ip checks in SSR trpc pre-caching requests
    ctx: await createTRPCContext({ isSSR: true }),
    transformer: superjson, // optional - adds superjson serialization
  });

  await ssg.location.getDistributors.prefetch();

  return {
    props: {
      trpcState: ssg.dehydrate(),
    },
    revalidate: 60,
  };
}

export { default } from "./BecomeARetailer";
